"use client";

import { SelectedValue, singleProp } from "@/interface/dataInterface";
import { expenseAndService } from "@/utils/objects";
import { FC, useEffect, useState } from "react";
import CommonEdit from "@/components/common/Edit";
import ExpenseForm from "../forms/ExpenseForm";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";
import axiosInstance from "@/utils/axiosInstance";

const ExpenseEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = useState(expenseAndService);
  const [otherData, setOtherData] = useState<SelectedValue[]>([]);

  useEffect(() => {
    if (!prop) return;
    const getExpense = async () => {
      const { data } = await axiosInstance.get(`/expenses/${prop}`);
      const { odometer, notes, date, vehicle_id, expense_type_values } = data;
      setFormProp({
        odometer: odometer || 0,
        notes: notes || "",
        time: seperateDateAndTime(date).timePart || "",
        vehicle_id: vehicle_id || 0,
        date: seperateDateAndTime(date).datePart || date,
      });
      setOtherData(
        expense_type_values.map((item: any) => ({
          id: item.expenses_type.id,
          name: item.expenses_type.name,
          value: item.value,
        })),
      );
    };

    getExpense();
  }, [prop]);

  return (
    <CommonEdit
      id={prop}
      title="Edit"
      resource="expenses"
      data={{
        ...formProp,
        date: mergeDateAndTime(formProp.date, formProp.time),
        vehicle_id: +formProp.vehicle_id,
        expense_type_list: otherData,
      }}
    >
      <ExpenseForm
        formProp={formProp}
        setFormProp={setFormProp}
        otherData={otherData}
        setOtherData={setOtherData}
      />
    </CommonEdit>
  );
};

export default ExpenseEdit;
